/* MARTYR theme JS - progressive enhancement.
   Server-side fallbacks exist for every flow (noscript variant select,
   cart Update button); this file replaces them with the smooth versions. */

(function () {
  'use strict';

  var qs = function (sel, root) { return (root || document).querySelector(sel); };
  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  var moneyFormat = function (cents) {
    var shopCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: shopCurrency
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  /* ---------- toast ---------- */

  var toastTimer;
  function toast(html) {
    var el = qs('#Toast');
    if (!el) return;
    el.innerHTML = html;
    el.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-open'); }, 4200);
  }

  /* ---------- daily splash ---------- */

  var splash = qs('#Splash');
  if (splash) {
    var mode = splash.getAttribute('data-frequency') || 'hour';
    var KEY = 'martyr-splash-last';
    var now = Date.now();
    var last = NaN;
    try { last = parseInt(localStorage.getItem(KEY), 10); } catch (e) { /* private mode */ }
    var seenRecently = false;
    if (!isNaN(last)) {
      if (mode === 'hour') {
        seenRecently = now - last < 3600000;
      } else {
        /* once a day = calendar day, so it returns at midnight */
        seenRecently = new Date(last).toDateString() === new Date(now).toDateString();
      }
    }

    if (mode === 'always' || !seenRecently) {
      try { localStorage.setItem(KEY, String(now)); } catch (e) { /* private mode */ }
      document.body.classList.add('ls-hold');
      splash.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { splash.classList.add('is-open'); });
      });
      splash.focus({ preventScroll: true });

      var revealShop = function () {
        splash.classList.remove('is-open', 'is-burst');
        splash.hidden = true;
        document.body.classList.remove('ls-hold');
        document.body.classList.add('ls-reveal');
      };

      if (splash.getAttribute('data-style') === 'anim') {
        /* The face holds, drifting, until the visitor enters -            click, Escape, or Enter/Space (it is a button). */
        var bursted = false;
        var burstSplash = function () {
          if (bursted) return;
          bursted = true;
          splash.classList.add('is-burst');
          setTimeout(revealShop, 320);
        };
        splash.addEventListener('click', burstSplash);
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') burstSplash();
        });
      } else {
        var splashClosed = false;
        var closeSplash = function () {
          if (splashClosed) return;
          splashClosed = true;
          splash.classList.remove('is-open');
          setTimeout(revealShop, 600);
        };
        splash.addEventListener('click', closeSplash);
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closeSplash();
        });
        var secs = parseInt(splash.getAttribute('data-seconds'), 10);
        if (secs > 0) setTimeout(closeSplash, secs * 1000);
      }
    }
  }

  /* ---------- quantity steppers ---------- */

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('.qty');
    var input = wrap && wrap.querySelector('input[type="number"]');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 0;
    input.value = Math.max(min, val + (plus ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product page ---------- */

  var productRoot = qs('[data-product]');
  if (productRoot) initProduct(productRoot);

  function initProduct(root) {
    var jsonEl = qs('[data-variant-json]', root);
    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { /* leave empty */ }

    var idInput = qs('[data-variant-id]', root);
    var priceEl = qs('[data-price]', root);
    var compareEl = qs('[data-compare]', root);
    var soldEl = qs('[data-unavailable]', root);
    var addBtn = qs('[data-add-button]', root);
    var form = qs('form[action*="/cart/add"]', root);

    /* gallery */
    var mainImg = qs('[data-gallery-main]', root);
    qsa('[data-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.getAttribute('data-large');
        mainImg.srcset = thumb.getAttribute('data-srcset') || '';
        qsa('[data-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });

    /* variant selection */
    function selectedOptions() {
      return qsa('.option', root).map(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function matchVariant() {
      var opts = selectedOptions();
      if (!opts.length) return variants[0] || null;
      return variants.find(function (v) {
        return opts.every(function (value, i) { return value === null || v.options[i] === value; });
      }) || null;
    }

    function renderVariant(variant) {
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        if (soldEl) soldEl.hidden = false;
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = moneyFormat(variant.price);
      if (compareEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = moneyFormat(variant.compare_at_price);
      }
      if (soldEl) soldEl.hidden = variant.available;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image.src;
        mainImg.srcset = '';
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (e) { /* older browsers keep the old URL */ }
    }

    qsa('.option input[type="radio"]', root).forEach(function (input) {
      input.addEventListener('change', function () { renderVariant(matchVariant()); });
    });

    /* ajax add to cart */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return; /* fall back to normal POST */
        e.preventDefault();
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' }
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } });
          })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            qsa('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            toast('Added to cart &nbsp;·&nbsp; <a href="' + root + 'cart">View Cart</a>');
          })
          .catch(function (err) {
            toast((err && err.description) || 'Could not add — please try again');
          })
          .finally(function () {
            var variant = matchVariant();
            if (addBtn && variant) {
              addBtn.disabled = !variant.available;
              addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
            }
          });
      });
    }
  }

  /* ---------- cart page: auto-update quantities ---------- */

  var cartForm = qs('form[action*="/cart"][data-cart-form]');
  if (cartForm) {
    /* JS handles updates automatically, so the no-JS Update button is noise */
    var updateBtn = qs('[data-cart-update]', cartForm);
    if (updateBtn) updateBtn.hidden = true;
    cartForm.addEventListener('change', function (e) {
      if (e.target.matches('input[type="number"]')) {
        cartForm.submit();
      }
    });
  }
})();
